import { Button } from "../ui/button";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";

import { Checkbox } from "../ui/checkbox";
import { useState } from "react";
import React from "react";
import {BidBaseModel} from "../bid/bidding_model";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "../ui/tooltip";

type SubmitBidProps = {
    onSubmit:  () => void;
    bid: BidBaseModel;
    enabled: boolean;
}

export function SubmitBidDialog(
    { onSubmit,
        bid,
        enabled

    }: SubmitBidProps)

{
    const [checked, setChecked] = useState(false);

    const handleChange = (event: any) => {
        setChecked(!checked);
    };

    const handleSubmit = () => {
        //console.log('submitting bid')
        onSubmit();
    };
    return (
        <Dialog>
            {/*<DialogTrigger asChild>*/}

            {/*    <Button disabled={enabled}>Submit Bid</Button>*/}
            {/*</DialogTrigger>*/}

             <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* span needed so tooltip fires even when button blocks pointer events */}
          <span className={!enabled ? "cursor-not-allowed" : ""}>
            <DialogTrigger asChild>
              <Button className={!enabled ? "pointer-events-none opacity-50" : ""}>
                Submit Bid
              </Button>
            </DialogTrigger>
          </span>
        </TooltipTrigger>
        {!enabled && (
          <TooltipContent>
            <p>Bid Amount must be greater than 0 </p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>

            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Submit Bid</DialogTitle>
                    <DialogDescription>
                        <br/>
                        Are you sure are ready to submit?
                        <br/>
                        Once you Submit, you will not be able to edit this bid.
                    </DialogDescription>
                </DialogHeader>
                <div className=" ">
                    <br />
                    <div className="flex items-center space-x-2">
                        <Checkbox id="terms" onCheckedChange={handleChange} />
                        <label
                            htmlFor="terms"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                            Yes
                        </label>
                    </div>
                    <br />
                </div>
                <DialogFooter className="sm:justify-start">
                    <DialogClose asChild>
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={handleSubmit}
                            disabled={!checked}
                            id="submitBidDialog"
                        >
                            Submit Bid
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
